import styled, { css } from 'styled-components'

import { mq, sizes } from '../../../../theme'
import FormLabel from '../../FormLabel'
import FormFieldToggleButton from '../FormFieldToggleButton'

export const Wrapper = styled.div<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`

export const Label = styled(FormLabel)`
  ${({ theme }) => theme.textStyles.titleH3}
  color: ${(props) => props.theme.colors.arapawa};
  margin-bottom: 2rem;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.gainsboro};
  padding: 4rem 0 0 0;
  margin-top: 2rem;
`
export const Subtitle = styled.p`
  ${({ theme }) => theme.textStyles.titleH5}
  color: ${(props) => props.theme.colors.bismark};
  margin-bottom: 1rem;
`

export const Options = styled.div<{ $asImage: boolean; $asSubtitle: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  ${({ $asImage }) =>
    $asImage &&
    css`
      grid-template-columns: repeat(
        auto-fill,
        min(calc(100% / 3 - 1rem), 12rem)
      );
      justify-content: center;
      justify-items: center;
    `}
  ${({ $asSubtitle }) =>
    $asSubtitle &&
    css`
      grid-template-columns: 1fr;
    `}

  @media ${mq(sizes.tablet)} {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
  }
`

export const ButtonContainer = styled.div`
  position: relative;
`

export const Pastille = styled.span<{ $asImage: boolean }>`
  ${({ theme }) => theme.textStyles.textXSmallStrong}
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-width: 1.8rem;
  height: 1.8rem;
  padding-inline: 0.2rem;
  border-radius: 50%;
  transform: translate(35%, -35%);
  background-color: ${(props) => props.theme.colors.atomicTangerine};
  ${({ $asImage, theme }) =>
    $asImage &&
    css`
      ${({ theme }) => theme.textStyles.titleH7}
      min-width: 3rem;
      height: 3rem;
      transform: translate(0, 0);
      background-color: ${theme.colors.ruby};
      color: ${theme.colors.pureWhite};
    `};
`

export const Checkbox = styled(FormFieldToggleButton)`
  width: 100%;
`
